module.exports = __webpack_public_path__ + "components/homepage-hero/static/hero-bg-1600@2x-3531eeec1ce077720ff0f2682868f87b.webp";